// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Order_Wrapper__3e4s4"};